<template>
  <router-link
    v-if="to.linktype === 'story' && to.cached_url"
    data-comp="h-slug"
    :to="to.cached_url.startsWith('/') ? to.cached_url : '/' + to.cached_url"
    :tabindex="tabindex"
  >
    <slot />
  </router-link>
  <a
    v-else-if="to.linktype === 'email' || to.email"
    data-comp="h-slug"
    :href="'mailto:' + to.email"
    :target="to.target"
    :tabindex="tabindex"
  >
    <slot />
  </a>
  <a v-else-if="to.url" data-comp="h-slug" :href="to.url" :target="target ? target : to.target" :tabindex="tabindex">
    <slot />
  </a>
</template>

<script setup>
defineProps({
  to: {
    type: Object,
    default: () => ({}),
  },
  target: {
    type: String,
    default: "_self",
  },
  tabindex: {
    type: Number,
    default: undefined,
  },
});
</script>
